export const CommunicationMethods = [
    { value: 'Email', label: 'Email' },
    { value: 'Cellphone', label: 'Cellphone' },
    { value: 'Telephone', label: 'Telephone' },
];
